import axios from '../axios'
// 获取权限菜单
export const findNavMenuTree = data => {
  return axios({
    url: '/auth/sysAuthorityMenu/agency/self_menu/2/' + data.agencyId,
    method: 'get',
    data
  })
}

// 获取赛事授权的权限菜单
export const findMatchMenuTree = data => {
  return axios({
    url: '/auth/sysAuthorityMenu/agency/match_role/2/' + data.agencyId,
    method: 'get',
    data
  })
}



// WEBPACK FOOTER //
// ./src/comm/http/modules/menu.js